'use strict';

const {
  idTypes,
  experimentSources,
  PARAMETER_LABEL,
  DEFAULT_COHORT
} = require('./constants');
const {
  validateApp,
  updateCohortAllocationsWithEid,
  generateDefaultAllocations,
  groupEligibleExperimentsById
} = require('./hivemind-client-helpers');
const {
  getSubjectKey,
  getCohortId,
  getSubjectIdType,
  treatmentsToCohortAllocations,
  transformSplitToExperiment
} = require('./splitio-helpers');
const { settingsToExperiments } = require('./switchboard-helpers');
const MockWrapper = require('./mock-wrapper');

module.exports = {
  hivemindConstants: {
    idTypes,
    experimentSources,
    PARAMETER_LABEL,
    DEFAULT_COHORT
  },
  MockWrapper,
  validateApp,
  updateCohortAllocationsWithEid,
  generateDefaultAllocations,
  groupEligibleExperimentsById,
  getSubjectKey,
  getCohortId,
  getSubjectIdType,
  treatmentsToCohortAllocations,
  transformSplitToExperiment,
  settingsToExperiments
};
